// Common JS - loaded on all pages
import handleMobileMenu from './mobileMenu';
import handleStickyHeader from './stickyHeader';
import handleBodyClasses from './handleBodyClasses';
import objectFitPolyfill from './objectFitPolyfill';

export default {
	/**
	 * Runs first before any JS
	 */
	init: () => {
		handleBodyClasses();
		handleStickyHeader();
		handleMobileMenu();
	},
	complete: () => {
		objectFitPolyfill();

		import( /* webpackChunkName: "plugins/am2-Slider" */ "./../../plugins/am2-Slider").then(() => {
			const { Slider } = am2;
			Slider.init(document.querySelectorAll('[data-plugin-slider]'));

			const sliders = document.querySelectorAll('.slider-images__js');
			console.log(sliders);
			if( sliders.length > 0 ) {
				sliders[0].swiper.controller.control = sliders[1].swiper;
				sliders[1].swiper.controller.control = sliders[0].swiper;
			}
		    
		});
	},
};
